module.exports = __webpack_public_path__ + "img/mobile-banner1-cn.7bf26dc7.jpg";